export enum AnalyticsAction {
  PLAY = 'play',
  PREVIEW = 'preview',
  CLICK = 'click',
}

export enum AnalyticsCategory {
  VIDEO = 'video',
  BUTTON = 'button',
  TEXT_TO_SPEECH = 'text to speech',
}
